import React, { useMemo, useState } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { Button } from '@src/components/Button/Button'
import { validateForm } from '@src/messages/validateForm'
import style from '@src/components/CallBackForm/CallBackForm.module.scss'
import { phoneRegexp } from '@src/lib/regex'
import { AppDispatch } from '@src/store/store'
import { callBack } from '@src/store/ducks/contacts/thunks'
import { selectLoadingIsSuccessCallBack } from '@src/store/ducks/contacts/selectors'

export const CallBackForm = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isLoading = useSelector(selectLoadingIsSuccessCallBack)
  const [userSend, setUserSend] = useState<string>('')
  const userSendTime:number = Math.floor(+new Date() / 1000)

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      name: Yup.string().required(validateForm.required),
      phone: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
    })
  ), [])

  const initialValues = useMemo(() => ({
    name: '',
    phone: '',
  }), [])

  return (
    <div className={style.box4}>
      <div className={style.text}>
        <span>Оформление заказа</span>
        {' '}
        на обратный звонок
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={({ name, phone }) => {
          const timeNow:number = Math.floor(+new Date() / 1000);
          if (Boolean(userSend) || timeNow - userSendTime < 3) {
            console.log('do not send')
            return
          }

          dispatch(callBack(name, phone))
        }}
        validationSchema={validationSchema}
      >
        {() => (
          <Form>
            <div className={style.usersend}>
              <input
                name="userSend"
                type="text"
                tabIndex={-1}
                value={userSend}
                onChange={(e) => {
                  setUserSend(e.target.value)
                }}
              />
              <input
                name="userSendTime"
                type="hidden"
                tabIndex={-1}
                value={userSendTime}
              />
            </div>

            <div className={style.box_1}>
              <FieldFormik
                label="Ваше имя"
                name="name"
                placeholder="Как к Вам обратиться?"
              />
              <FieldFormik
                label="Контактный номер"
                name="phone"
                placeholder="+375 (ХХ) ХХХ ХХ ХХ"
                mask="+{375} (00) 000-00-00"
              />
            </div>
            <div className={style.btnBlock}>
              <Button htmlType="submit" type="primary" loading={isLoading}>
                Отправить заявку
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
